<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="tab-item-ctn">
            <div class="search-ctn">
                <div class="search-ctn-right">
                    <div class="search-name">供应商名称</div>
                    <el-select
                        class="search-item"
                        size="small"
                        v-model="searchData.CusId"
                        remote
                        filterable
                        allow-create
                        placeholder="请输入供应商名称"
                        :remote-method="searchSupplier"
                        v-select-scroll-more="searchSupplierLoad"
                    >
                        <el-option v-for="item in supplierOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusId"> </el-option>
                    </el-select>
                    <div class="search-name">支付方式</div>
                    <el-select class="search-item" size="small" v-model="searchData.PayType">
                        <el-option label="全部" value></el-option>
                        <el-option v-for="item in payWayList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                    </el-select>
                    <div class="search-name">时间区间</div>
                    <el-date-picker
                        v-model="dateTimes"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                        @change="handleChange"
                        size="small"
                        class="search-name"
                    ></el-date-picker>
                    <div class="search-name">
                        <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="getPurchaseTableData">查询</el-button>
                        <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                    </div>
                </div>
            </div>
            <div class="table-ctn">
                <el-table
                    :header-cell-style="{ background: '#F2F6FC' }"
                    :data="tablePurchaseData"
                    border
                    style="width: 100%"
                    :default-sort="{ prop: 'PayAmount', order: 'ascending' }"
                    :summary-method="getSummaries"
                    show-summary
                >
                    <el-table-column show-overflow-tooltip width="80px" type="index" sortable label="排名"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="100px" prop="PayTypeName" label="付款方式"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="100px" prop="PayAmount" sortable label="已付款"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="100px" prop="ReturnAmount" sortable label="已退款"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="100px" label="实付金额" sortable prop="Amount"></el-table-column>
                    <el-table-column show-overflow-tooltip sortable min-width="100" prop="OrderCount" label="订单总数"></el-table-column>
                    <el-table-column show-overflow-tooltip sortable min-width="90" prop="PayCount" label="付款笔数"></el-table-column>
                    <el-table-column show-overflow-tooltip sortable min-width="90" prop="ReturnCount" label="退款笔数"></el-table-column>
                    <el-table-column show-overflow-tooltip sortable min-width="100" prop="CusTotalCount" label="收款供应商总数"></el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
export default {
    mixins: [mixin],
    name: '',
    components: {
        breadcrumb
    },
    data() {
        return {
            dateTimes: [],
            searchData: {
                CusId: '',
                StartDate: '',
                EndDate: '',
                PayType: '',
                SortProp: '',
                SortType: ''
            },
            payWayList: [],
            tablePurchaseData: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            // 用于供应商列表，分页搜索
            supplierOptions: [],
            supplierForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            }
        };
    },
    created() {
        //当前设定的日期时间
        let d = new Date();
        let year1, month1, day1;
        [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
        let date1 = new Date(year1, month1, day1, 0);
        this.dateTimes.push(date1);
        //前一天设定的日期时间
        let year2, month2, day2;
        d.setTime(d.getTime());
        [year2, month2, day2] = [d.getFullYear(), d.getMonth(), 1];
        let date2 = new Date(year2, month2, day2, 0);
        this.dateTimes.unshift(date2);

        this.searchData.StartDate = date2;
        this.searchData.EndDate = date1;
    },
    mounted() {
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.getPurchaseTableData();
        this.getPay();
        this.searchSupplier();
    },
    methods: {
        // 供应商列表，搜索
        async searchSupplier(key) {
            if (![undefined].includes(key)) {
                this.supplierForm.Page = 1;
                this.supplierForm.stopLoad = false;
                this.supplierForm.key = key;
                this.supplierOptions = [];
            }
            if (this.supplierForm.stopLoad) return;
            const data = await this.$util.searchSupplier(this.supplierForm.key, this.supplierForm.Page, this.supplierForm.Limit);
            if (data) {
                if (!data) return;
                this.supplierForm.stopLoad = data.length < this.supplierForm.Limit;
                this.supplierOptions = [...this.supplierOptions, ...data];
            }
        },
        // 供应商列表，加载更多
        searchSupplierLoad() {
            this.supplierForm.Page += 1;
            this.searchSupplier();
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    if (index === 2 || index === 3 || index === 4) sums[index] = sums[index].toFixed(2) + ' 元';
                    else sums[index] = sums[index] + '';
                } else {
                    sums[index] = '';
                }
            });

            return sums;
        },
        // 重置表单
        resetSearch() {
            this.searchData.CusId = '';
            this.searchData.Name = '';
            this.searchData.StartDate = '';
            this.searchData.EndDate = '';
            this.searchData.PayType = '';
            this.dateTimes = [];
            this.SortProp = '';
            this.SortType = '';
            // this.searchSupplier('');
        },
        // 获取数据
        getPurchaseTableData() {
            this.$util
                .axiosGet({
                    url: '/api/DataStatistics/PurchasePayTypeStatistics',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    this.tablePurchaseData = data;
                })
                .catch(() => {});
        },
        handleChange(val) {
            if (val) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        handleSelect(item) {
            this.searchData.CusId = item.value;
        },
        //  结算方式
        getPay() {
            this.$util.getPay().then(data => {
                this.payWayList = data;
            });
        }
    }
};
</script>
